import { getCookie } from 'cookies-next';
import axios from '../axios-config';

const deleteUserAddress = async ({ mage, id }) => {
  const config = {
    method: 'delete',
    url: `/customer/address/${id}`,
    headers: {
      mage: 'Bearer ' + mage,
    },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const getAllUserAddress = async (mage) => {
  const config = {
    method: 'get',
    url: `/customer/address`,
    headers: {
      mage: 'Bearer ' + mage,
    },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const addUpdateUserAddress = async (mage, address) => {
  const data = JSON.stringify({ address });
  let config = {
    method: 'PUT',
    url: '/customer/address',
    headers: {
      mage: 'Bearer ' + mage,
      admin: 'Bearer ' + process.env.NEXT_PUBLIC_ADMIN_TOKEN,
    },
    data,
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const getAllCities = async (mage) => {
  const token = getCookie('mage');

  const config = {
    method: 'get',
    url: `/customer/getCities`,
    headers: {
      mage: 'Bearer ' + mage ?? token,
    },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const getAvailablePayments = async (handshake, mage, quote) => {
  const checkQuote = mage ? '0' : '1';

  const config = {
    method: 'get',
    url: `/mstore/available-payment-methods/${checkQuote}`,
    headers: {
      Authorization: `Bearer ${handshake}`,
      ...(mage ? { mage: 'Bearer ' + mage } : {}),
      ...(quote ? { quote: 'Bearer ' + quote } : {}),
    },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const getCustomerCity = async ({ lat, long }) => {
  const data = JSON.stringify({
    lat,
    long,
  });
  const config = {
    method: 'post',
    url: '/customer/get-customer-city',
    data,
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

export {
  getAllUserAddress,
  addUpdateUserAddress,
  deleteUserAddress,
  getAllCities,
  getAvailablePayments,
  getCustomerCity,
};
